const { request } = require('./request');

const baseURL = "/api/webhooks";

export const fetchWebhooks = () => {
    return request(baseURL);
};

export const createWebhook = (webhook) => {
    return request(baseURL, {
        method: 'POST',
        json: webhook
    });
};

export const updateWebhook = (webhookId, updates) => {
    return request(`${baseURL}/${webhookId}`, {
        method: 'PATCH',
        json: updates
    });
};

export const deleteWebhook = (webhookId) => {
    return request(`${baseURL}/${webhookId}`, {
        method: 'DELETE'
    });
};

export const testWebhook = (webhookId) => {
    return request(`${baseURL}/${webhookId}/test`, {
        method: 'POST'
    });
};

export const getWebhookStats = (webhookId = null) => {
    const url = webhookId ? `${baseURL}/${webhookId}/stats` : `${baseURL}/stats`;
    return request(url);
};